// @ts-nocheck
import axios from "axios"
import { createContext, Dispatch, SetStateAction, useContext, useEffect, useState } from "react";
import {Outlet, Navigate, useNavigate} from "react-router-dom"
import apiClient from "./ApiClient";
import { useMutation } from "@tanstack/react-query";
import { AuthVerify } from "@/components/ApiRoutes";
import { toast } from "sonner";
import LoginDialog from "@/components/LoginDialog";
import MainLoader from "./Loaders";


interface UsernameContextType {
    username: string;
    setUsername: Dispatch<SetStateAction<string>>;
  }
  
  export const UsernameContext = createContext<UsernameContextType>({
    username: "",
    setUsername: () => {}
  });


const ProtectedRoutes = () => {
    const [isAuth, setIsAuth] = useState(false); 
    const [username, setUsername] = useState("");
    const value: UsernameContextType = { username, setUsername };
    const navigate = useNavigate();
    
    const postVerify = useMutation({
        mutationFn: (variables) => 
            AuthVerify(variables.access),

        onSuccess: (data, variables) => {
            // we shouldnt really do anythiung here, just verify the token
            setIsAuth(true);
        },
        onError: (error) => {
            toast.error("Authentication failed. Please log in again.");
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('username');
            setIsAuth(false);
        }
    });



    useEffect(() => {
        const accessToken = localStorage.getItem("accessToken");
        if (!accessToken) {
            setIsAuth(false);
            return;
        }

        
        postVerify.mutate({ access: accessToken });
        
    }, [window.location.pathname]);


    if(postVerify.isPending){
        return(<MainLoader />)
    }

    if(isAuth){
        return (

            <Outlet />
        )
        
    }
    return(
        <LoginDialog open={true}>
            <></>
        </LoginDialog>
    )
        
};

export default ProtectedRoutes